//это не vue-компонент, а код сделаный по старинке. Переписать. Или он уже переписан?
class PageProjects{
    constructor(){
        this.node = document.querySelector('.page-projects');
        if (!this.node) return;
        this._setProjectLinesQty()
        this._tempTest();
    }
    _setProjectLinesQty(){
      let placesForProject = this.node.querySelectorAll('.place-for--project');
      let projectsQty = placesForProject.length;

      //для разрешений поменьше
      this.node.style.setProperty("--projectsQty", projectsQty + 1);  //+1 для заголовка

      //для разрешений побольше
      let projectLinesQty = Math.floor(projectsQty / 2) + 1;
      this.node.style.setProperty("--projectLinesQty", projectLinesQty);
    }
    _tempTest(){
      // let node = document.querySelector('.block-footer');
      let node = document.querySelector('.place-for--title');
      node.addEventListener('click', ()=>{
        console.log('click on node');
      })
    }
}

export default PageProjects;



// WEBPACK FOOTER //
// ./src/layout/PageProjects.js